// extracted by mini-css-extract-plugin
module.exports = {"hmubweg":"hmubweg"};